import React from "react";

/**
 * Pinned top bar of every KYC VARA screen: back (left), title, close (right),
 * then "Step 2 of 5" with step dots. Leave `step` empty on screens outside the numbered form.
 */
function StepHeader({ title, onBack, onClose, step, totalSteps }) {
  const showProgress = Boolean(step && totalSteps);

  // A <div>, not <header>: the site CSS styles every <header> (fixed 70px height, flex, padding).
  return (
    <div className="kv-header">
      <div className="kv-header__bar">
        {onBack ? (
          <button type="button" className="kv-icon-btn" onClick={onBack} aria-label="Back">
            <i className="ri-arrow-left-s-line" aria-hidden="true" />
          </button>
        ) : (
          <span className="kv-icon-btn kv-icon-btn--placeholder" aria-hidden="true" />
        )}

        <div className="kv-header__center">
          <h1 className="kv-header__title">{title}</h1>
          {showProgress ? <p className="kv-header__step">Step {step} of {totalSteps}</p> : null}
        </div>

        {onClose ? (
          <button type="button" className="kv-icon-btn" onClick={onClose} aria-label="Close">
            <i className="ri-close-line" aria-hidden="true" />
          </button>
        ) : (
          <span className="kv-icon-btn kv-icon-btn--placeholder" aria-hidden="true" />
        )}
      </div>

      {showProgress ? (
        <ol className="kv-dots" aria-hidden="true">
          {Array.from({ length: totalSteps }, (_, index) => {
            let state = "";
            if (index < step - 1) state = "is-done";
            if (index === step - 1) state = "is-current";
            return <li key={index} className={state} />;
          })}
        </ol>
      ) : null}
    </div>
  );
}

export default StepHeader;
